/**
 * @module app.shared
 */

import { autoinject, bindingMode, observable, TaskQueue } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

import { IToggle } from 'app/shared/elements/forms/input-base';
import { getKey, Key } from 'app/shared/lib/keys';

const CONFIRM_KEYS = [
    Key.Enter,
    Key.Space
]

@autoinject()
export class EssSwitchCustomElement implements IToggle {

    ////****************** Fields and Properties ************************************////
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public checked: any = null;

    @bindable.string()
    public testName: string = '';

    @bindable.stringNull()
    public ariaSwitchLabel: string | null = null;

    @bindable()
    public value?: string;

    @bindable()
    public autocomplete: string = 'off';

    @bindable()
    public readonly: boolean = false;

    @bindable()
    public disabled: boolean = false;

    ////****************** Element References ***************************************////
    protected checkbox!: HTMLInputElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(protected readonly taskQueue: TaskQueue) { }

    ////****************** Events ***************************************************////
    protected handleKeydown(event: KeyboardEvent): boolean {
        if(!event.defaultPrevented && CONFIRM_KEYS.includes(getKey(event) as Key)) {
            this.taskQueue.queueTask(() => this.checkbox.click());
            return false;
        }
        return true;
    }

    protected handleInputFocus(event: FocusEvent) {
        //Adds materialize class to show focus. Materialize does not apply do this innately when we use .focus() on the input
        this.taskQueue.queueTask(() => this.checkbox.classList.add('tabbed'));
    }
}
